import { AuthIntakeSupervisorAuths } from "./authIntakeSupervisorAuths";

export class AuthIntakeSupervisorAuthsData {
    auths!: AuthIntakeSupervisorAuths[];
    rowCount!: number;
    overdueCount!: number;
    uniqueValues!: string;
}
